
import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import MasterShopSpecifyLayout from 'components/organismos/master/labor/MasterShopSpecifyLayout';

const MasterShopSpecifyPage = () => (
  <SidebarTemplate>
    <MasterShopSpecifyLayout />
  </SidebarTemplate>
);

export default MasterShopSpecifyPage;
